<input class="search-input" [ngModel]="value" placeholder="Type to search" (ngModelChange)="updateSearch($event)" />
<div *ngIf="isCancelButtonVisible">
  <button class="search-input-button" (click)="cancelEmitter()">Cancel</button>
</div>
